// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_6y-3";
export var contentContainer = "_6y-0";
export var editorContainer = "_6y-1";
export var quillInputForm = "_6y-2";
export var zoneDivider = "_6y-4";